import PropTypes from 'prop-types';
import React from 'react';
import Autocomplete from '../utils/Autocomplete';

class CreativeProducts extends React.Component {

  handleSelect = selected => {
    const evt = {
      target: { name: 'CreativeProducts', value: selected }
    };
    this.props.onChange(evt);
  };

  filterByProgrammaticRules = () => {
    const { creativeProducts, creativeSource, orderType } = this.props;
    let filteredProducts = creativeProducts;
    if (orderType !== 'Programmatic') {
      return filteredProducts.filter(cp => cp.progRule !== 'progOnly');
    }
    if (creativeSource === 'Advertiser Provided') {
      filteredProducts = creativeProducts.filter(cp => cp.progAdvProvided === 'Y');
    } else {
      filteredProducts = creativeProducts.filter(cp => cp.progRule !== 'progOnly');
    }
    return filteredProducts;
  };

  render() {
    const { value, disabled } = this.props;
    const filteredProducts = this.filterByProgrammaticRules();
    return (
      <Autocomplete
        onChange={this.handleSelect}
        value={value}
        suggestions={filteredProducts}
        name="CreativeProducts"
        suggestionKey="name"
        label="Creative Products"
        disabled={disabled}
        placeholder="Select or start typing"
      />
    );
  }
}

CreativeProducts.defaultProps = {
  value: [],
  creativeSource: '',
  orderType: 'Standard',
  disabled: false
};

CreativeProducts.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  creativeProducts: PropTypes.array.isRequired,
  creativeSource: PropTypes.string,
  orderType: PropTypes.string,
  disabled: PropTypes.bool
};

export default CreativeProducts;
